import { render, staticRenderFns } from "./SvCalendar.vue?vue&type=template&id=64260dd8&scoped=true&lang=pug&"
import script from "./SvCalendar.vue?vue&type=script&lang=js&"
export * from "./SvCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SvCalendar.vue?vue&type=style&index=0&id=64260dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64260dd8",
  null
  
)

export default component.exports